export const QUERY_PREVIEW_LIMIT = 100;

/**
 * Single source of truth for the query text shown on a history row.
 * `comment` wins over `description` so the visible text, the collapsed preview
 * and the checkbox accessible name all describe the same string.
 */
export function getQueryText(historyItem) {
  return historyItem?.comment || historyItem?.description || '';
}

/**
 * Derived view state for a row's query text. Kept as one helper because the row
 * (checkbox alignment) and the query content itself must agree on when the
 * structure thumbnail is visible.
 */
export function getQueryDisplayState(historyItem, isExpanded) {
  const text = getQueryText(historyItem);
  const hasQuickSearchStructure = Boolean(historyItem?.quickSearchItem?.structure);
  const hasStructureListItem = (historyItem?.structures?.length || 0) > 0;
  const isTruncated = text.length > QUERY_PREVIEW_LIMIT;
  const isCollapsed = isTruncated && !isExpanded;

  return {
    hasQuickSearchStructure,
    hasStructureListItem,
    showToggle: isTruncated,
    showStructure: (hasQuickSearchStructure || hasStructureListItem) && !isCollapsed,
    displayedText: isCollapsed ? `${text.slice(0, QUERY_PREVIEW_LIMIT).trimEnd()}...` : text,
  };
}
